import sha1 from 'js-sha1'
import axios from 'axios'

function RongCloud () {
    this.appkey = window.AppConfig.RongCloudAppKey
    this.appSecret = window.AppConfig.RongCloudAppSecret
    this.baseurl = window.AppConfig.RongCloudBaseUrl
}

RongCloud.prototype.signature = function() {
	const timestamp = (new Date()).getTime()
	const nonce = parseInt(Math.random()*timestamp)
	const signature = sha1(this.appSecret + "" + nonce + "" + timestamp)
	
	return {
		timestamp, nonce, signature
	}
} 

RongCloud.prototype.getToken = function(userId, name, portraitUri, callback) {
	let _this = this
	
	const { timestamp, nonce, signature } = _this.signature()
	
	const data = {
		userId, name, portraitUri
	}
	let _data = ""
	for (var i in data) {
		if (_data) {
			_data += "&"
		}
		_data += i + "="+encodeURIComponent(data[i])
	}
	
	axios.post(_this.baseurl + "/user/getToken.json", _data, {
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
			"App-Key": _this.appkey,
			"Nonce": nonce,
			"Timestamp": timestamp,
			"Signature": signature,
		},
		withCredentials: false,
	}).then(({ data }) => {
		const { token } = data
		if (typeof callback == "function") {
			callback(token)
		}
	}).catch((error) => {
		console.log(error)
	})
}

const _RongCloud = new RongCloud()

export default _RongCloud
